import HostFreeAreaService from '@/services/free-area/host-free-area'

export class MypageFreeArea extends HostFreeAreaService {
  protected get freeAreaPaths(): string[] {
    return [
      'MypageTopHeader',
    ]
  }
}
